/* EASE Advertorial: buy box (colour, one or two chains, prices, Klarna rate) and the silent video loops.
   Add to cart itself is the theme's <form is="product-form">; this script only keeps its inputs right. */
(function () {
  'use strict';

  // ponytail: euro only, as the shop sells in EUR; read shop.money_format if other currencies come.
  function euro(cents) {
    var text = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return text.replace(/,00$/, '') + ' €';
  }

  function setText(root, selector, text) {
    root.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
  }

  function initKauf(box) {
    var form = box.querySelector('form');
    if (!form) return;
    var rateK = parseFloat(box.dataset.rateK) || 0;
    var keep = (100 - (parseFloat(box.dataset.duo) || 0)) / 100;
    var cut = box.querySelector('[data-adv-cut]');
    var panel = box.querySelector('[data-adv-farben-panel]');
    var zweite = box.querySelector('[data-adv-zweite]');
    var duoCard = box.querySelector('.ease-adv-menge--duo');

    function chosen(slot) {
      return box.querySelector('[data-adv-slot="' + slot + '"] [data-adv-farbe]:checked');
    }

    function syncZweiteToErste() {
      var first = chosen(0);
      if (!first || !zweite || zweite.dataset.touched) return;
      var second = chosen(1);
      if (second && second.value === first.value) return;
      // Until the second row is touched, keep it in step with the first colour.
      var match = box.querySelector('[data-adv-slot="1"] [data-adv-farbe][value="' + first.value + '"]');
      if (match && !match.disabled) match.checked = true;
    }

    function update() {
      var menge = box.querySelector('[data-adv-menge]:checked');
      var zwei = menge && menge.value === '2';
      if (zwei) syncZweiteToErste();
      var first = chosen(0);
      var second = (zwei && chosen(1)) || first;
      if (!first) return;

      var p1 = parseInt(first.dataset.price, 10);
      var p2 = parseInt(second.dataset.price, 10);
      var full = p1 + p2;
      var total = zwei ? full * keep : p1;

      setText(box, '[data-adv-farblabel="0"]', first.dataset.label);
      setText(box, '[data-adv-farblabel="1"]', second.dataset.label);
      setText(box, '[data-adv-preis1]', euro(p1));
      var uvp = parseInt(first.dataset.uvp, 10) || 0;
      setText(box, '[data-adv-uvp]', uvp ? euro(uvp) : '');
      box.querySelectorAll('[data-adv-uvp-row]').forEach(function (el) { el.hidden = !uvp; });
      setText(box, '[data-adv-preis2alt]', euro(full));
      setText(box, '[data-adv-preis2]', euro(full * keep));
      setText(box, '[data-adv-knopfpreis]', euro(total));
      if (rateK) setText(box, '[data-adv-rate]', euro(Math.round(total * rateK)));
      if (cut && first.dataset.cut) cut.src = first.dataset.cut;

      if (panel) panel.classList.toggle('ease-adv-farben-panel--duo', zwei);
      if (duoCard) duoCard.classList.toggle('ease-adv-menge--offen', zwei);
      if (zweite) zweite.hidden = !zwei;
      box.querySelectorAll('[data-adv-farbe-legende="1"]').forEach(function (el) { el.hidden = zwei; });
      box.querySelectorAll('[data-adv-farbe-legende="2"]').forEach(function (el) { el.hidden = !zwei; });

      // One chain posts id + property, two chains post items[]; the unused set is disabled, so it is not sent.
      form.querySelectorAll('[data-adv-einzel]').forEach(function (el) { el.disabled = zwei; });
      form.querySelectorAll('[data-adv-zwei]').forEach(function (el) { el.disabled = !zwei; });
      form.querySelectorAll('[data-adv-item]').forEach(function (el) {
        el.disabled = !zwei;
        el.value = el.dataset.advItem === '0' ? first.value : second.value;
      });
      var id = form.querySelector('input[name="id"]');
      if (id) id.value = first.value;
    }

    if (zweite) {
      zweite.addEventListener('change', function () {
        zweite.dataset.touched = '1';
      });
    }

    /* gallery: swipe, arrows, dots, counter; a colour click shows that variant's image */
    var slidesEl = box.querySelector('[data-adv-slides]');
    var slides = slidesEl ? Array.prototype.slice.call(slidesEl.querySelectorAll('[data-adv-slide]')) : [];
    var dots = box.querySelector('[data-adv-dots]');
    var count = box.querySelector('[data-adv-count]');
    var prev = box.querySelector('[data-adv-prev]');
    var next = box.querySelector('[data-adv-next]');

    function index() {
      return Math.min(slides.length - 1, Math.round(slidesEl.scrollLeft / slidesEl.clientWidth));
    }
    function mark() {
      var k = index();
      Array.prototype.forEach.call(dots.children, function (dot, j) { dot.classList.toggle('ease-adv-on', j === k); });
      count.textContent = k + 1 + ' / ' + slides.length;
      prev.disabled = k === 0;
      next.disabled = k === slides.length - 1;
    }
    function go(k) {
      k = Math.max(0, Math.min(slides.length - 1, k));
      slidesEl.scrollTo({ left: k * slidesEl.clientWidth, behavior: 'smooth' });
    }
    if (slidesEl && slides.length > 1) {
      slides.forEach(function () { dots.appendChild(document.createElement('i')); });
      prev.addEventListener('click', function () { go(index() - 1); });
      next.addEventListener('click', function () { go(index() + 1); });
      slidesEl.addEventListener('scroll', mark, { passive: true });
      slidesEl.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); go(index() + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(index() - 1); }
      });
      mark();
    } else if (prev) {
      prev.hidden = next.hidden = true;
    }

    box.addEventListener('change', function (event) {
      var media = event.target.dataset && event.target.dataset.media;
      if (!media || media === '0' || !slidesEl) return;
      var k = slides.map(function (slide) { return slide.getAttribute('data-adv-slide'); }).indexOf('m-' + media);
      if (k >= 0) go(k);
    });
    box.addEventListener('change', update);
    // the theme re-enables the id input when the form element upgrades; settle the state after that
    setTimeout(update, 0);
    update();
  }

  function initVideos() {
    var videos = document.querySelectorAll('.ease-adv [data-adv-video]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    videos.forEach(function (video) {
      var ton = video.parentNode.querySelector('[data-adv-ton]');
      if (still) {
        video.controls = true;
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) video.play().catch(function () {});
          else video.pause();
        }, { threshold: 0.6 }).observe(video);
      }
      // a tap on the picture pauses or resumes the loop (WCAG 2.2.2)
      video.addEventListener('click', function () {
        if (video.paused) video.play().catch(function () {});
        else video.pause();
      });
      if (!ton) return;
      ton.addEventListener('click', function () {
        var on = video.muted;
        // only one video speaks at a time
        videos.forEach(function (other) {
          other.muted = true;
          var b = other.parentNode.querySelector('[data-adv-ton]');
          if (b) { b.setAttribute('aria-pressed', 'false'); b.textContent = b.dataset.on || 'Ton an'; }
        });
        video.muted = !on;
        if (on) video.play().catch(function () {});
        ton.setAttribute('aria-pressed', on ? 'true' : 'false');
        // labels come from the page language (data-on / data-off), German as fallback
        ton.textContent = on ? ton.dataset.off || 'Ton aus' : ton.dataset.on || 'Ton an';
      });
    });
  }

  function init() {
    document.querySelectorAll('.ease-adv [data-adv-kauf]').forEach(initKauf);
    initVideos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
